import { ProprieteAffichee } from "../proprieteAffichee";

export class Lithology {
    id: number;
    name= '';
    code= '';
    rockType= '';
    description= '';
    color = '#FFFFFF';
    regionId = 0;
    siteId?: number;
    isActive = true;


    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('id', 'GLOBAL.IDENTIFICATEUR'));
        tab.push(new ProprieteAffichee('name', 'GLOBAL.NOM'));
        tab.push(new ProprieteAffichee('code', 'PRODUCTS.CODE'));
        tab.push(new ProprieteAffichee('rockType', 'GLOBAL.ROCK_TYPE'));
        tab.push(new ProprieteAffichee('description', 'GLOBAL.DESCRIPTION'));
        tab.push(new ProprieteAffichee('color', 'PRODUCTS.TYPECOLOR'));
        return tab;
      }

  }
  